import { SearchEntryRacerInputParam } from '@/lib/apollo/types/gen/graphql';
import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY_FROM_SCREEN = 'from-screen';
const KEY_FROM_SCREEN_URL = 'from-screen-url';
const KEY_SEARCH_CONDITION = 'from-search-condition';
const KEY_SORT_CONDITION = 'from-sort-condition';

export const PAST_ATTRIBUTE_SCORE_RANGE = 6;

/** 選手詳細戻り先モード */
export const fromScreenStorage = CustomSessionStorage<'race' | 'search'>(
  KEY_FROM_SCREEN,
);

/** 選手詳細戻り先URL */
export const fromScreenUrlStorage =
  CustomSessionStorage<string>(KEY_FROM_SCREEN_URL);

/** 選手検索条件 */
export const searchConditionStorage =
  CustomSessionStorage<SearchEntryRacerInputParam>(KEY_SEARCH_CONDITION);

/** 選手検索ソート条件 */
export const searchSortStorage =
  CustomSessionStorage<string>(KEY_SORT_CONDITION);
